import React from 'react';
import ReactMarkdown from 'react-markdown';
import Wrap from './styled';
function Markdown(_a) {
    var text = _a.text;
    return (React.createElement(Wrap, null,
        React.createElement(ReactMarkdown, null, text)));
}
export default Markdown;
